import { applyMiddleware, compose, createStore } from 'redux';
import reduxSagaMiddleware from 'redux-saga';

import reducer from '../reducer';
import sagas from '../sagas';

const sagaMiddleware = reduxSagaMiddleware();
const store = createStore(
  reducer,
  compose(
    applyMiddleware(sagaMiddleware),
    (window as any).__REDUX_DEVTOOLS_EXTENSION__
      ? (window as any).__REDUX_DEVTOOLS_EXTENSION__()
      : (f: any) => f
  )
);

export type RootState = ReturnType<typeof reducer>;
export type AppDispatch = typeof store.dispatch;

export default store;
sagaMiddleware.run(sagas);
